import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\WikiPlace\GetPlaceListForSelectController::__invoke
* @see app/Http/Controllers/WikiPlace/GetPlaceListForSelectController.php
* @route '/api/place-for-select-migrator/{type}'
*/
const GetPlaceListForSelectController5d8237fcc3375178a83f53690847abd2 = (args: { type: string | number } | [type: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetPlaceListForSelectController5d8237fcc3375178a83f53690847abd2.url(args, options),
    method: 'get',
})

GetPlaceListForSelectController5d8237fcc3375178a83f53690847abd2.definition = {
    methods: ["get","head"],
    url: '/api/place-for-select-migrator/{type}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\WikiPlace\GetPlaceListForSelectController::__invoke
* @see app/Http/Controllers/WikiPlace/GetPlaceListForSelectController.php
* @route '/api/place-for-select-migrator/{type}'
*/
GetPlaceListForSelectController5d8237fcc3375178a83f53690847abd2.url = (args: { type: string | number } | [type: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { type: args }
    }

    if (Array.isArray(args)) {
        args = {
            type: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        type: args.type,
    }

    return GetPlaceListForSelectController5d8237fcc3375178a83f53690847abd2.definition.url
            .replace('{type}', parsedArgs.type.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\WikiPlace\GetPlaceListForSelectController::__invoke
* @see app/Http/Controllers/WikiPlace/GetPlaceListForSelectController.php
* @route '/api/place-for-select-migrator/{type}'
*/
GetPlaceListForSelectController5d8237fcc3375178a83f53690847abd2.get = (args: { type: string | number } | [type: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetPlaceListForSelectController5d8237fcc3375178a83f53690847abd2.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WikiPlace\GetPlaceListForSelectController::__invoke
* @see app/Http/Controllers/WikiPlace/GetPlaceListForSelectController.php
* @route '/api/place-for-select-migrator/{type}'
*/
GetPlaceListForSelectController5d8237fcc3375178a83f53690847abd2.head = (args: { type: string | number } | [type: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetPlaceListForSelectController5d8237fcc3375178a83f53690847abd2.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\WikiPlace\GetPlaceListForSelectController::__invoke
* @see app/Http/Controllers/WikiPlace/GetPlaceListForSelectController.php
* @route '/api/place-for-select/{place_type}'
*/
const GetPlaceListForSelectControllerd93fb238a7f6e792c98f77f71bf72a2e = (args: { place_type: string | number } | [place_type: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetPlaceListForSelectControllerd93fb238a7f6e792c98f77f71bf72a2e.url(args, options),
    method: 'get',
})

GetPlaceListForSelectControllerd93fb238a7f6e792c98f77f71bf72a2e.definition = {
    methods: ["get","head"],
    url: '/api/place-for-select/{place_type}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\WikiPlace\GetPlaceListForSelectController::__invoke
* @see app/Http/Controllers/WikiPlace/GetPlaceListForSelectController.php
* @route '/api/place-for-select/{place_type}'
*/
GetPlaceListForSelectControllerd93fb238a7f6e792c98f77f71bf72a2e.url = (args: { place_type: string | number } | [place_type: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { place_type: args }
    }

    if (Array.isArray(args)) {
        args = {
            place_type: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        place_type: args.place_type,
    }

    return GetPlaceListForSelectControllerd93fb238a7f6e792c98f77f71bf72a2e.definition.url
            .replace('{place_type}', parsedArgs.place_type.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\WikiPlace\GetPlaceListForSelectController::__invoke
* @see app/Http/Controllers/WikiPlace/GetPlaceListForSelectController.php
* @route '/api/place-for-select/{place_type}'
*/
GetPlaceListForSelectControllerd93fb238a7f6e792c98f77f71bf72a2e.get = (args: { place_type: string | number } | [place_type: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetPlaceListForSelectControllerd93fb238a7f6e792c98f77f71bf72a2e.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WikiPlace\GetPlaceListForSelectController::__invoke
* @see app/Http/Controllers/WikiPlace/GetPlaceListForSelectController.php
* @route '/api/place-for-select/{place_type}'
*/
GetPlaceListForSelectControllerd93fb238a7f6e792c98f77f71bf72a2e.head = (args: { place_type: string | number } | [place_type: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetPlaceListForSelectControllerd93fb238a7f6e792c98f77f71bf72a2e.url(args, options),
    method: 'head',
})

/**
* Multiple routes resolve to \App\Http\Controllers\WikiPlace\GetPlaceListForSelectController::GetPlaceListForSelectController, so this export is a
* dictionary keyed by URI rather than a callable, with the verbs prefixed where two routes share a URI.
* Call a specific route with `GetPlaceListForSelectController['<key>'](...)`, or import the route by name from your
* generated `routes/` directory.
*/
const GetPlaceListForSelectController = {
    '/api/place-for-select-migrator/{type}': GetPlaceListForSelectController5d8237fcc3375178a83f53690847abd2,
    '/api/place-for-select/{place_type}': GetPlaceListForSelectControllerd93fb238a7f6e792c98f77f71bf72a2e,
}

export default GetPlaceListForSelectController